import * as React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles';
import { Dialog } from '@lean-body/components/molecules';
import { Button, ButtonType } from '../atoms';
import { StreakFreezeIcon } from '../atoms/icons/streak_freeze_icon';
export const StreakFreezeStockDialog = ({ onClickCancel }) => {
    return (React.createElement(Dialog, { onClickCancel: onClickCancel, classObject: styles.dialog, content: React.createElement(React.Fragment, null,
            React.createElement("div", { className: css(styles.header) },
                React.createElement("div", { className: css(styles.title) }, "\u30D5\u30EA\u30FC\u30BA\u306B\u3064\u3044\u3066")),
            React.createElement("div", { className: css(styles.content) },
                React.createElement(StreakFreezeIcon, { classObject: styles.freezeIcon }),
                React.createElement("div", { className: css(styles.description) },
                    "\u30D5\u30EA\u30FC\u30BA1\u500B\u3067\u3001\u9023\u7D9A\u8A18\u9332\u30921\u65E5\u5206\u30AD\u30FC\u30D7\u3067\u304D\u308B\u3088\u3002",
                    React.createElement("br", null),
                    "\u9054\u6210\u3059\u308B\u305F\u3073\u306B1\u3064\u88DC\u5145\u3055\u308C\u308B\u3088\u3002"),
                React.createElement(Button, { buttonType: ButtonType.blue, onClick: onClickCancel, isRadius: true, fullWidth: true }, "OK"))) }));
};
const styles = StyleSheet.create({
    dialog: {
        position: 'absolute',
        top: 'unset',
        bottom: 0,
        backgroundColor: Colors.White,
        left: 'none',
        transform: 'none',
        width: '100%',
        borderRadius: '14px 14px 0 0',
        [MediaBreakPointUp.MD]: {
            position: 'relative',
            top: '30%',
            width: 375,
            height: 392,
            margin: 'auto',
            borderRadius: 14,
        },
    },
    header: {
        color: Colors.TextDark,
        textAlign: 'center',
        padding: 16,
    },
    title: {
        fontSize: 14,
        fontWeight: 700,
        lineHeight: '140%',
        letterSpacing: 0.56,
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '32px 24px',
    },
    freezeIcon: {
        width: 134,
        height: 120,
        marginBottom: 16,
    },
    description: {
        color: Colors.Black,
        textAlign: 'center',
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '140%',
        letterSpacing: 1.28,
        marginBottom: 24,
    },
});
